function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_advancedsignup:customdeploy_ns_sc_ext_sl_advancedsignup":"/app/site/hosting/scriptlet.nl?script=663&deploy=1&compid=3799678&ns-at=AAEJ7tMQWdZWLqTAnNEcccmSD0g5y1lFjf7TqF_fWLxSNHcT_2w","customscript_ns_sc_ext_sl_newsletter_sp:customdeploy_ns_sc_ext_sl_newsletter_sp":"/app/site/hosting/scriptlet.nl?script=554&deploy=1&compid=3799678&ns-at=AAEJ7tMQQsi85zhM9Yshgn-5oip-TiBnnaQRQpMLy5J6a_AAr3U","customscript_ns_sc_ext_sl_orderstatus_of:customdeploy_ns_sc_ext_sl_orderstatus_of":"/app/site/hosting/scriptlet.nl?script=538&deploy=1&compid=3799678&ns-at=AAEJ7tMQdm2fyjKkspmiP-X5V6BxOH2VlfRZmhnX4Amwx9AzlsA","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=530&deploy=1&compid=3799678&ns-at=AAEJ7tMQwcKbRAwsMkSAhiqw-_4ER70MuheRFPpn-BMWJrtEvEY","customscript_ns_sc_sl_id_isb:customdeploy_ns_sc_sl_id_isb":"/app/site/hosting/scriptlet.nl?script=1435&deploy=1&compid=3799678&ns-at=AAEJ7tMQo8C3REZc_J3jwvW8SDwZYelFEsVPpO3WaxcB6pYV9ns","customscript_ns_sc_sl_inventory_display:customdeploy_ns_sc_sl_inventory_display":"/app/site/hosting/scriptlet.nl?script=541&deploy=1&compid=3799678&ns-at=AAEJ7tMQwHXL7A6GreYxfE2kk3_PJi09yCBIsGMmKLso_7-JTkE","customscript_ns_sc_sl_itembadges:customdeploy_ns_sc_sl_itembadges":"/app/site/hosting/scriptlet.nl?script=543&deploy=1&compid=3799678&ns-at=AAEJ7tMQioHqZBJLIzX54EbH7ONcJ4iCNrfnaFoxeyWOB9S4Usg"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}